var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaverse7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2C7.75 1.58579 7.41421 1.25 7 1.25H4C2.48122 1.25 1.25 2.48122 1.25 4V7C1.25 7.41421 1.58579 7.75 2 7.75C2.41421 7.75 2.75 7.41421 2.75 7V4C2.75 3.30964 3.30964 2.75 4 2.75H7C7.41421 2.75 7.75 2.41421 7.75 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2C16.25 1.58579 16.5858 1.25 17 1.25H20C21.5188 1.25 22.75 2.48122 22.75 4V7C22.75 7.41421 22.4142 7.75 22 7.75C21.5858 7.75 21.25 7.41421 21.25 7V4C21.25 3.30964 20.6904 2.75 20 2.75H17C16.5858 2.75 16.25 2.41421 16.25 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8807 12.3116C17.389 12.0086 17.5742 11.3797 17.3072 10.8627L13.0497 2.61664C12.6252 1.79445 11.4137 1.79445 10.9892 2.61664L6.73166 10.8627C6.4647 11.3797 6.64985 12.0086 7.15824 12.3116L11.4157 14.8488C11.786 15.0694 12.2529 15.0694 12.6231 14.8488L16.8807 12.3116Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9852 21.4924C12.531 22.1692 11.5079 22.1692 11.0536 21.4924L6.53887 14.7661C6.47192 14.6663 6.59119 14.5479 6.69583 14.6103L11.4157 17.4231C11.786 17.6437 12.2529 17.6437 12.6231 17.4231L17.3431 14.6103C17.4477 14.5479 17.567 14.6663 17.5 14.7661L12.9852 21.4924Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.75C16.5858 22.75 16.25 22.4142 16.25 22C16.25 21.5858 16.5858 21.25 17 21.25H20C20.6904 21.25 21.25 20.6904 21.25 20V17C21.25 16.5858 21.5858 16.25 22 16.25C22.4142 16.25 22.75 16.5858 22.75 17V20C22.75 21.5188 21.5188 22.75 20 22.75H17Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75C7.41421 22.75 7.75 22.4142 7.75 22C7.75 21.5858 7.41421 21.25 7 21.25H4C3.30964 21.25 2.75 20.6904 2.75 20V17C2.75 16.5858 2.41421 16.25 2 16.25C1.58579 16.25 1.25 16.5858 1.25 17V20C1.25 21.5188 2.48122 22.75 4 22.75H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse7);
export default __webpack_public_path__ + "static/media/metaverse-7.8225d1384dbdd50ad58717b1906bdc7b.svg";
export { ForwardRef as ReactComponent };